<template>
  <layout-blank>
    <template v-slot:nav>
      <navigation :inverse="true" :showBack="{ mobile: true, desktop: false }" :showFilter="{ mobile: false, desktop: true }" />
    </template>

    <a class="back-button" @click="$router.back()">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" class="icon" svg-inline="" role="presentation" focusable="false" tabindex="-1"><path d="M16.975 6.797a2 2 0 112.828 2.829L7.43 21.999 45 22a2 2 0 110 4H7.826L19.8 37.974a2 2 0 01.117 2.701l-.117.127a2 2 0 01-2.828 0L1.529 25.362a1.992 1.992 0 01-.725-1.323 1.997 1.997 0 01.746-1.819z"/></svg>
      <span class="text">Go Back</span>
    </a>

    <div class="grid" v-if="Object.keys(property).length > 0">
      <carousel :items="property.OtherImages" />

      <div class="info">
        <div class="header">
          <div class="actions">
            <button type="button" class="favourite button button--link button--link-inline button--inline-icon" @click="handleFavourite">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" class="icon" svg-inline="" role="presentation" focusable="false" tabindex="-1"><path d="M34.202 4.185c-3.94 0-7.633 1.692-10.202 4.555a13.709 13.709 0 00-10.202-4.555C6.242 4.185.095 10.333.095 17.89c0 14.656 21.995 26.562 22.93 27.06a2.07 2.07 0 001.95 0c.935-.5 22.93-12.404 22.93-27.06 0-7.556-6.147-13.704-13.703-13.704zm-.566 29.79c-3.9 3.302-7.855 5.737-9.636 6.773-1.781-1.036-5.736-3.47-9.636-6.774-4.622-3.913-10.13-9.88-10.13-16.085 0-5.275 4.29-9.566 9.564-9.566a9.573 9.573 0 018.389 4.967 2.07 2.07 0 003.626 0 9.572 9.572 0 018.389-4.967c5.274 0 9.565 4.291 9.565 9.566 0 6.205-5.51 12.172-10.13 16.085z"/></svg>
              {{ favouriteText }}
            </button>
            <router-link class="next button button--link button--link-inline" :to="nextProperty" v-if="nextProperty">
              View next property
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" class="icon" svg-inline="" role="presentation" focusable="false" tabindex="-1"><path d="M30.81 40.8A2 2 0 1128 38l12.36-12.4H2.79a2 2 0 010-4H40l-12-12a2 2 0 01-.12-2.7l.12-.1a2 2 0 012.83 0l15.43 15.44a2 2 0 010 3.14z"/></svg>
            </router-link>
          </div>
          <div class="tags">
            <tag color="red">{{ property.ContractType }}</tag>
            <tag>{{ property.TransactionType }}</tag>
          </div>
        </div>

        <h1 class="info-heading h3">{{ property.TotalBedrooms }} Bedroom {{ property.PropertyType }}</h1>
        <h2 class="info-heading h4 t-normal">{{ property.Town }}, Malta | {{ property.Price | formatPrice }}</h2>
        <p class="info-ref t-normal"><small>MLS ID: {{ property.MLS }}</small></p>

        <div class="info-summary">
          <figure>
            <img src="@/assets/icons/bed.svg" alt="">
            <figcaption>{{ property.TotalBedrooms }} Bedrooms</figcaption>
          </figure>

          <figure>
            <img src="@/assets/icons/shower.svg" alt="">
            <figcaption>{{ property.TotalBathrooms }} Bathrooms</figcaption>
          </figure>

          <figure>
            <img src="@/assets/icons/size.svg" alt="">
            <figcaption>{{ property.TotalSqm }}m<sup>2</sup></figcaption>
          </figure>
        </div>

        <p class="info-description">{{ property.Description }}</p>

        <div class="table">
          <div class="row">
            No. of rooms: <strong>{{ property.TotalRooms }}</strong>
          </div>
          <div class="row">
            External area: <strong>{{ property.TotalExtArea }}m<sup>2</sup></strong>
          </div>
        </div>

        <h3 class="info-sub-heading">Features</h3>
        <ul class="checklist">
          <li v-for="feature in property.Features">{{ feature.Name }}</li>
        </ul>
      </div>

      <aside class="branch">
        <div class="agent">
          <img class="agent-img" :src="agentImage" alt="">

          <div class="agent-details">
            <h1 class="h3">{{ property.Agent.Name }} {{ property.Agent.Surname }}</h1>
            <p>{{ property.Agent.Title }}</p>
          </div>
        </div>

        <div class="branch-details">
          <p><strong>{{ property.Office.OfficeName }}</strong></p>
          <p>{{ property.Office.Address }}</p>
        </div>

        <div class="enquire-form">
          <h3 class="enquire-heading t-center">Enquire about this property</h3>
          <enquire-form :properties="[property.MLS]" />
        </div>
      </aside>
    </div>
  </layout-blank>
</template>

<style scoped lang="scss">
  .grid {
    padding-bottom: 40px;

    @include min-md {
      display: grid;

      grid-template-columns: 40% 60%;
      grid-template-rows: repeat(24, 5vw) auto;

      .carousel {
        grid-column: 1;
        grid-row: 1 / span 5;
      }

      .info {
        margin-left: 16%;
      }

      .branch {
        align-self: flex-start;
        grid-column: 1;
        grid-row: 6;

        margin-top: 20px;

        @include min-md {
          .enquire-button {
            display: none;
          }

          .button-fixed {
            margin: 0 0 20px;
            padding: 0;

            .button {
              width: 100%;
              margin-left: 0;
              margin-right: 0;
            }
          }
        }
      }
    }

    @include min-lg {
      grid-template-rows: repeat(20, 65px) auto;
    }
  }

  .info {
    .header {
      margin-bottom: 20px;

      .actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
      }

      @include min-md {
        display: flex;
        align-items: center;
        width: 100%;

        .actions {
          order: 1;
          margin-bottom: 0;
          margin-left: auto;

          .next {
            margin-left: 30px;

            .icon {
              width: 1.8rem;
              height: 1.8rem;
              margin-left: 10px;
            }
          }
        }

        .tags {
          order: 0;
        }
      }
    }
  }

  .info-heading {
    margin-bottom: 5px;
  }

  .info-sub-heading {
    margin-bottom: 15px;
  }

  .info-ref {
    margin-bottom: 15px;
    line-height: 1;
  }

  .info-summary {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;

    @include min-sm {
      justify-content: flex-start;
    }

    figure {
      margin: 1em 2em;
      text-align: center;

      @include min-sm {
        &:first-child {
          margin-left: 0;
        }
      }

      figcaption {
        font-size: var(--small);
        font-weight: var(--weight-bold);
      }
    }
  }

  .info-description {
    text-align: justify;
  }

  .table {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    padding: 10px 0;

    border-top: 1px solid rgb(var(--gray-10));
    border-bottom: 1px solid rgb(var(--gray-10));

    font-size: var(--p);

    @include min-md {
      flex-direction: row;
      padding: 0;
    }

    .row {
      display: flex;
      justify-content: space-between;

      margin: 10px 0;

      @include min-md {
        display: block;
        margin: 20px 60px 20px 0;
      }
    }
  }

  .checklist {
    margin: 0 0 30px;
    padding: 0 0 30px;
    columns: 2 auto;

    list-style: none;

    border-bottom: 1px solid rgb(var(--gray-10));

    @include min-md {
      border: 0;
    }

    li {
      margin-bottom: 1em;
      padding-left: 2em;

      font-size: var(--p);
      background-image: url('~@/assets/icons/check.svg');
      background-repeat: no-repeat;
      background-position: 0 -4px;
    }
  }

  .agent {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .button {
      @include min-sm {
        min-width: 100px;
      }
    }

    .agent-img {
      flex: 0 0 auto;
      width: 100px;
      height: 100px;
      border-radius: 4px;
      object-fit: cover;
      background-color: rgb(var(--gray-0));

      @include min-sm {
        width: 86px;
        height: 86px;
      }
    }

    .agent-details {
      width: 100%;
      padding: 10px;

      .h3, p {
        margin: 0;
      }
    }
  }

  .branch-details {
    p {
      margin-bottom: 0;
      font-size: var(--small);
    }
  }

  .back-button {
    display: none;

    @include min-md {
      display: inline-flex;
      align-items: center;
      margin-top: -10px;
      margin-bottom: 20px;

      font-size: var(--small);
      font-weight: var(--weight-bold);
      color: rgb(var(--blue-0));
      fill: rgb(var(--blue-0));

      cursor: pointer;

      .icon {
        width: 1.8rem;
        height: 1.8rem;
        margin-right: 10px;
      }
    }
  }

  .enquire-form {
    ::v-deep button[type="submit"] {
      width: 100%;
    }

    ::v-deep p {
      @include min-md {
        width: 100%;
        text-align: left;
      }
    }
  }

  .enquire-heading {
    margin-top: 20px;
    margin-bottom: 10px;
    color: rgb(var(--blue-0));

    @include min-md {
      text-align: left;
    }
  }
</style>

<script>
  import { remax } from '@/api';
  import { mapState, mapActions } from 'vuex';

  import LayoutBlank from '@/layouts/Blank';
  import Navigation from '@/components/Navigation';
  import Tag from '@/components/Tag';
  import Carousel from '@/components/Carousel';
  import EnquireForm from '@/components/EnquireForm';
  import { formatPrice } from '@/filters';

  export default {
    name: 'Property',

    head: {
      link () {
        return [
          { rel: 'canonical', href: `https://www.remax-malta.com/${ this.id }`, id: 'canonical' }
        ]
      }
    },

    components: {
      LayoutBlank,
      Navigation,
      Tag,
      Carousel,
      EnquireForm
    },

    filters: {
      formatPrice
    },

    props: {
      id: {
        type: String,
        required: true
      }
    },

    data: () => ({
      property: {}
    }),

    computed: {
      ...mapState([
        'user'
      ]),

      isLiked () {
        return this.user.likedProperties.find(el => el.property_id === this.property.MLS);
      },

      favouriteText () {
        return `${ this.isLiked ? 'Unfavourite' : 'Favourite' }`;
      },

      agentImage () {
        return this.property.Agent.Photos[0].ImageURL || 'https://www.remax-malta.com/common/images/default_image_agent.gif';
      },

      nextProperty () {
        const properties = this.$store.state.properties;
        const selfIndex = properties.findIndex(el => el.MLS === this.property.MLS);
        const next = (properties.length - 1 === selfIndex) ? null : selfIndex + 1;

        if (next) return `/properties/${ properties[next].MLS }`;

        return false
      }
    },

    methods: {
      ...mapActions([
        'addLikedProperty',
        'removeLikedProperty',
      ]),

      handleFavourite () {
        this.isLiked ? this.removeLikedProperty(this.property.MLS) : this.addLikedProperty(this.property.MLS);
      },

      async fetchProperty (id) {
        this.$store.commit('updateLoading', true);

        this.property = {};

        await remax.getProperty(id)
          .then(({ data }) => this.property = data.Listing)
          .catch(({ data }) => console.log(data))

        window.addthis_share = {
          // url: `https://www.remax-malta.com/${ this.id }`,
          title: `${ this.property.TotalBedrooms } Bedroom ${ this.property.PropertyType }`,
          description: this.property.Description,
          media: this.property.Image
        }

        this.$store.commit('updateLoading', false)
      }
    },

    beforeRouteUpdate (to, from, next) {
      this.fetchProperty(to.params.id);
      next();
    },

    created () {
      this.addThis = document.createElement('script');
      this.addThis.setAttribute('type', 'text/javascript');
      this.addThis.setAttribute('language', 'javascript');
      this.addThis.setAttribute('src', '//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5dc7e4595e06caf4');

      // Append script
      document.body.appendChild(this.addThis);

      this.fetchProperty(this.id);
    },

    beforeDestroy () {
      this.addThis.remove();
      window.addthis_share = null;
    }
  };
</script>